import type { ContentBlock } from '@nimbus/types'

interface TextNode {
    text?: unknown
    children?: unknown
}

function nodeText(node: TextNode): string {
    if (typeof node.text === 'string') return node.text
    if (!Array.isArray(node.children)) return ''

    return node.children.map(child => nodeText(child as TextNode)).join('')
}

/** `text` cut at a word boundary to fit `maxLength`, ellipsis included, e.g. for a meta description. */
export function truncateAtWord(text: string, maxLength = 155): string {
    const clean = text.replace(/\s+/g, ' ').trim()

    if (clean.length <= maxLength) return clean

    // One character is reserved for the ellipsis; a cut that ends a word (next is a space or punctuation) keeps it.
    const cut = clean.slice(0, maxLength - 1)
    const lastSpace = /[\p{L}\p{N}]/u.test(clean[maxLength - 1]!) ? cut.lastIndexOf(' ') : cut.length

    return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).replace(/[\s,.;:–-]+$/, '')}…`
}

/**
 * Plain text of the paragraphs in rich-text content, cut at a word boundary to fit `maxLength`
 * (with the ellipsis). Headings, lists and images are skipped so the excerpt reads as prose,
 * e.g. for a meta description.
 */
export function contentBlocksToExcerpt(blocks: ContentBlock[] | null | undefined, maxLength = 155): string {
    const text = (blocks ?? [])
        .filter(block => (block as { type?: unknown }).type === 'paragraph')
        .map(block => nodeText(block as TextNode))
        .join(' ')

    return truncateAtWord(text, maxLength)
}
